export namespace WorkflowWebhookModel {
  export enum WebhookAuthType {
    NONE = 'none',
    BASIC = 'basic',
    JWT = 'jwt',
  }
  export type WebhookHttpMethod = 'GET' | 'POST';

  export interface WebhookCredentialDto {
    username?: string;
    password?: string;
    token?: string;
  }

  export interface WebhookOptionsDto {
    allowOrigins?: string[];
    allowIps?: string[];
  }

  export interface WebhookConfigDto {
    authType: WebhookAuthType;
    method: WebhookHttpMethod;
    credential?: WebhookCredentialDto;
    options?: WebhookOptionsDto;
  }

  export enum WebhookRouteTargetType {
    temporalTriggerWebhook = 'temporalTriggerWebhook',
    temporalWaitWebhook = 'temporalWaitWebhook',
    emptyTarget = 'emptyTarget',
  }

  export type WebhookTargetDto =
    | {
        targetType: WebhookRouteTargetType.emptyTarget;
      }
    | {
        targetType: WebhookRouteTargetType.temporalTriggerWebhook;
        temporalTriggerWebhookTargetConfig: {
          graphId: string;
          nodeId: string;
        };
      }
    | {
        targetType: WebhookRouteTargetType.temporalWaitWebhook;
        temporalWaitWebhookTargetConfig: {
          graphId: string;
          nodeId: string;
        };
      };

  export interface WebhookRouteTarget {
    type: WebhookRouteTargetType;
    graphId?: string;
    nodeId?: string;
  }

  export interface WebhookEndpointMongoDocument {
    _id: string;
    orgId: string;
    name?: string;
    customPath: string;
    path: string;
    config: WebhookConfigDto;
    target: WebhookRouteTarget;
    createdAt: number;
    updatedAt: number;
    url: string;
  }

  export interface CreateWebhookDto {
    name?: string;
    target: WebhookTargetDto;
    config: WebhookConfigDto;
  }

  export interface UpdateWebhookDto {
    name?: string;
    target?: WebhookTargetDto;
    config?: Partial<WebhookConfigDto>;
  }
}
